import moment from "moment";
import CommonModal from "../../../../../../core/common/commonModal";
import LeaveForm from "../../../../../../core/common/leaveForm";
import { DAY_TYPES } from "../utils/leaveConstants";

interface EditLeaveModalProps {
    visible: boolean;
    selectedLeave: any;
    leaveTypes: any[];
    leaveBalances: any[];
    onClose: () => void;
    onSubmit: (values: any) => Promise<void>;
}

const EditLeaveModal: React.FC<EditLeaveModalProps> = ({
    visible,
    selectedLeave,
    leaveTypes,
    leaveBalances,
    onClose,
    onSubmit,
}) => {
    return (
        <CommonModal
            id="edit_leaves_modal"
            title="Edit Leave"
            visible={visible}
            onClose={onClose}
        >
            {selectedLeave && (
                <LeaveForm
                    mode="edit"
                    leaveTypes={leaveTypes}
                    dayTypes={DAY_TYPES}
                    initialValues={{
                        leaveType: selectedLeave.LeaveTypes,
                        fromDate: moment(selectedLeave.startDate).format("DD-MM-YYYY"),
                        toDate: moment(selectedLeave.endDate).format("DD-MM-YYYY"),
                        dayType: "Full Day",
                        reason: selectedLeave.reason,
                        documents: selectedLeave.documents,
                        startDayPart: selectedLeave.startDayPart || "full",
                        endDayPart: selectedLeave.endDayPart || "full",
                    }}
                    leaveBalances={leaveBalances}
                    onSubmit={onSubmit}
                    onCancel={onClose}
                />
            )}
        </CommonModal>
    );
};

export default EditLeaveModal;
